import { render, staticRenderFns } from "./NovaToast.vue?vue&type=template&id=a2e5b23c&lang=pug&"
import script from "./NovaToast.vue?vue&type=script&lang=js&"
export * from "./NovaToast.vue?vue&type=script&lang=js&"
import style0 from "./NovaToast.vue?vue&type=style&index=0&id=a2e5b23c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports